import { CASNotificationEvent } from 'shared'
import CIMSNotifications from 'components/CIMSNotifications'
import RecipientsSelectProvider from 'components/CIMSSelect/common/RecipientsSelect/RecipientsSelectContext'
import CASNotificationsProvider, {
  useCASNotificationsContext,
} from './CASNotificationsContext'
import { useEdit } from './hooks/useEdit'
import ViewCASNotifications from './components/ViewCASNotifications'
import CASNotificationsDetails from './components/CASNotificationsDetails'

const InnerNotifications: React.FC = () => {
  const { refetch: onReload, loading } = useCASNotificationsContext()
  const edit = useEdit()
  return (
    <CIMSNotifications
      events={CASNotificationEvent.values}
      edit={edit}
      onReload={onReload}
      view={<ViewCASNotifications />}
      loading={loading}
      details={<CASNotificationsDetails />}
    />
  )
}

const Notifications: React.FC = () => {
  return (
    <RecipientsSelectProvider>
      <CASNotificationsProvider>
        <InnerNotifications />
      </CASNotificationsProvider>
    </RecipientsSelectProvider>
  )
}

export default Notifications
